import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  updateActiveTab,
  changeFilterContainerVisibility,
  updateFilterConditions,
  applyFilter,
} from '@store/filterContainer/actions';
import { pushDrilldownFilter } from '@store/dimensionContainer/actions';
import { selector as commonSelector } from '@store/common';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { compareOnTrendsModeSelector } from '@store/trends/base/selectors';
import FilterDropdown from './FilterDropdown';

const selector = createSelector(
  commonSelector,
  filterContainerSelector,
  compareOnTrendsModeSelector,
  (commonStore, filterContainerStore, compareOnTrendsMode) => ({
    filterColor: commonStore.filterColor,
    isGrandfatherFilter: commonStore.isGrandfatherFilter,
    appliedFilter: commonStore.appliedFilters[0],
    filters: filterContainerStore.filters,
    visible: filterContainerStore.visible,
    compareOnTrendsMode,
  }),
);

export default connect(selector, {
  applyFilter,
  changeFilterContainerVisibility,
  updateActiveTab,
  updateFilterConditions,
  pushDrilldownFilter,
})(FilterDropdown);
